import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  contact: {
    id: 'portal.views.contact.title.part1',
    defaultMessage: 'Contact',
    description: 'Contact word in heading',
  },
  support: {
    id: 'portal.views.contact.title.part2',
    defaultMessage: 'Support',
    description: 'Support word in heading',
  },
  welcomeText: {
    id: 'portal.views.contact.welcomeText',
    defaultMessage: 'We welcome your valuable input and are eager to engage with our community of learners. '
      + 'Your questions, insights, and feedback are instrumental to our continuous growth and improvement.',
    description: 'Welcome text for contact page',
  },
  contactUsPrompt: {
    id: 'portal.views.contact.contactUsPrompt',
    defaultMessage: 'Please contact us with your questions or support requests.',
    description: 'Prompt to contact us',
  },
  sendEmail: {
    id: 'portal.views.contact.sendEmail',
    defaultMessage: 'Send us an email:',
    description: 'Send us an email label',
  },
  fullNameLabel: {
    id: 'portal.views.contact.field.fullName.label',
    defaultMessage: 'Full Name',
    description: 'Full name label',
  },
  fullNamePlaceholder: {
    id: 'portal.views.contact.field.fullName.placeholder',
    defaultMessage: 'John Smith',
    description: 'Full name placeholder',
  },
  emailLabel: {
    id: 'portal.views.contact.field.email.label',
    defaultMessage: 'Email',
    description: 'Email label',
  },
  emailPlaceholder: {
    id: 'portal.views.contact.field.email.placeholder',
    defaultMessage: 'youremail@address.com',
    description: 'Email placeholder',
  },
  phoneNumberLabel: {
    id: 'portal.views.contact.field.phoneNumber.label',
    defaultMessage: 'Phone Number',
    description: 'Phone number label',
  },
  phoneNumberPlaceholder: {
    id: 'portal.views.contact.field.phoneNumber.placeholder',
    defaultMessage: 'Enter your phone number',
    description: 'Phone number placeholder',
  },
  companyLabel: {
    id: 'portal.views.contact.field.company.label',
    defaultMessage: 'Company/Organisation',
    description: 'Company/Organisation label',
  },
  companyPlaceholder: {
    id: 'portal.views.contact.field.company.placeholder',
    defaultMessage: 'Enter your company/organisation',
    description: 'Company/Organisation placeholder',
  },
  howCanWeHelpLabel: {
    id: 'portal.views.contact.field.howCanWeHelp.label',
    defaultMessage: 'How can we help?',
    description: 'How can we help label',
  },
  howCanWeHelpLabelPlaceholder: {
    id: 'portal.views.contact.field.howCanWeHelp.placeholder',
    defaultMessage: 'Tell us about your needs...',
    description: 'Tell us about your needs placeholder',
  },
  sendButton: {
    id: 'portal.views.contact.send.button.text',
    defaultMessage: 'Send Message',
    description: 'Send message button',
  },
  thankYouMessage: {
    id: 'portal.views.contact.thankYou.message',
    defaultMessage: 'Thank you for contacting us. We will get back to you shortly.',
    description: 'Thank you for contacting us message',
  },
  requiredField: {
    id: 'portal.views.contact.field.validation.required',
    defaultMessage: 'This field is required.',
    description: 'Required field validation',
  },
  invalidEmail: {
    id: 'portal.views.contact.field.validation.invalidEmail',
    defaultMessage: 'Please enter a valid email address.',
    description: 'Invalid email validation',
  },
  invalidPhoneNumber: {
    id: 'portal.views.contact.field.validation.invalidPhoneNumber',
    defaultMessage: 'Please enter a valid international phone number, e.g., +12025550147.',
    description: 'Invalid phone number validation',
  },
  contactFormSubject: {
    id: 'portal.views.contact.form.subject',
    defaultMessage: 'Contact Form Submission',
    description: 'Contact form email subject',
  },
});

export default messages;
